import { render, staticRenderFns } from "./AddPromocode.vue?vue&type=template&id=14820651&"
import script from "./AddPromocode.vue?vue&type=script&lang=js&"
export * from "./AddPromocode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports